// extracted by mini-css-extract-plugin
module.exports = {"keyStatistics":"KeyStats_keyStatistics__u_vme","tableKeyStats":"KeyStats_tableKeyStats__2LS_p","borderUpper":"KeyStats_borderUpper__3WiwP"};